export default function Segmented({ value, onChange, options, size = 'md', className = '' }) {
  return (
    <div className={`cn-segmented ${size === 'sm' ? 'cn-segmented--sm' : ''} ${className}`.trim()} role="tablist">
      {options.map((o) => (
        <button key={o.key} role="tab" className="cn-segmented-btn" data-active={o.key === value ? 'true' : 'false'} aria-selected={o.key === value} onClick={() => onChange(o.key)}>
          {o.label}
        </button>
      ))}
    </div>
  )
}
